import { makeStyles } from 'tss-react/mui';

import { linearProgressClasses } from '@mui/material';

export default makeStyles({ name: 'Authorization' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: 12,
        gap: 16,
        borderRadius: 20,
        border: '1px solid #ECECEC',
        background: '#F8F8F8'
    },
    _compact: {
        padding: 4,
        borderRadius: 25
    },
    avatar: {
        cursor: 'pointer'
    },
    user: {
        cursor: 'default',
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    text: {
        display: 'flex',
        flexDirection: 'column'
    },
    name: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px'
    },
    credits: {
        color: '#5F5F5F',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        ':after': {
            color: '#8E8E8E',
            content: "' 'attr(data-after)"
        }
    },
    progress: {
        background: '#E4E4E4',
        borderRadius: 2,
        [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: '#2D2D2D',
            borderRadius: 2
        }
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    }
});
